export default "__VITE_ASSET__BHGGfzVn__"